import React from 'react';

type Props = {
  align: 'vertical' | 'horizontal';
  labelComponent: React.ReactNode;
  formComponent: React.ReactNode;
};

export default function LabelForm({
  align = 'vertical',
  labelComponent,
  formComponent,
}: Props) {
  const isHorizontal = align === 'horizontal';

  return (
    <div
      className={`flex ${isHorizontal ? 'w-full flex-row gap-6' : 'flex-col gap-2'}`}
    >
      {labelComponent && (
        <div
          className={
            isHorizontal
              ? 'flex h-fit min-h-12 flex-[0_0_148px] flex-col items-start justify-center'
              : 'flex-1'
          }
        >
          {labelComponent}
        </div>
      )}
      {formComponent && <div className="w-full flex-1">{formComponent}</div>}
    </div>
  );
}
